import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RDO } from '@core';

@Component({
  selector: 'app-rdo-select',
  templateUrl: './rdo-select.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RDOSelectComponent),
      multi: true
    }
  ]
})
export class RDOSelectComponent implements ControlValueAccessor {
  statusLabel: { [key: number]: string } = {};
  options = [
    ...RDO.sort((a: any, b: any) => {
      return a.name.localeCompare(b.name);
    })
  ];
  // sort = {default: 'ascend'};

  @Input() value: number = 0;
  @Input() disabled = false;
  @Input() borderless = false;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    if (item) return item.label;
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
